import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {AccountSearchModel} from "../account-search.model";
import {AccountSearchPageComponent} from "../account-search-page/account-search-page.component";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-account-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(AccountSearchModel),
        registerSearchControl(AccountMultiSelectSearchControlComponent)
    ]
})

export class AccountMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<AccountSearchModel> implements OnInit {
    @Input() accountingType: number[];

    constructor(model: AccountSearchModel, injector: Injector) {
        super(model, injector, "accountId", "accountName");
        this.extendedSearchComponent = AccountSearchPageComponent;
    }

    ngOnInit(): void {
        this.model.filter[AccountSearchModel.ACCOUNTING_TYPE_FILTER_NAME] = this.accountingType;
    }
}
